import { __awaiter as o, __generator as h } from "./index11.js";
import { isThenable as f } from "./index56.js";
import { version as p } from "./index20.js";
var c = function(a, t, e) {
  e.getCalls(a).forEach(function(r) {
    i(t, r).catch(console.error);
  });
}, M = function(a, t) {
  return o(void 0, void 0, void 0, function() {
    var e, r, n;
    return h(this, function(s) {
      switch (s.label) {
        case 0:
          e = 0, r = t.getCalls("addSourceMiddleware"), s.label = 1;
        case 1:
          return e < r.length ? (n = r[e], [4, i(a, n).catch(console.error)]) : [3, 4];
        case 2:
          s.sent(), s.label = 3;
        case 3:
          return e++, [3, 1];
        case 4:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}, _ = c.bind(void 0, "on"), b = c.bind(void 0, "setAnonymousId"), w = function(a, t) {
  t.toArray().forEach(function(e) {
    setTimeout(function() {
      i(a, e).catch(console.error);
    }, 0);
  });
}, v = (
  /** @class */
  function() {
    function a() {
      this._value = {};
    }
    return a.prototype.toArray = function() {
      var t;
      return (t = []).concat.apply(t, Object.values(this._value));
    }, a.prototype.getCalls = function(t) {
      var e;
      return (e = this._value[t]) !== null && e !== void 0 ? e : [];
    }, a.prototype.push = function() {
      for (var t = this, e = [], r = 0; r < arguments.length; r++)
        e[r] = arguments[r];
      return e.forEach(function(n) {
        t._value[n.method] ? t._value[n.method].push(n) : t._value[n.method] = [n];
      }), this;
    }, a.prototype.clear = function() {
      return this._value = {}, this;
    }, a;
  }()
);
function i(a, t) {
  return o(this, void 0, void 0, function() {
    var e, r;
    return h(this, function(n) {
      switch (n.label) {
        case 0:
          return n.trys.push([0, 3, , 4]), t.called ? [2, void 0] : (t.called = !0, e = a[t.method].apply(a, t.args), f(e) ? [4, e] : [3, 2]);
        case 1:
          n.sent(), n.label = 2;
        case 2:
          return t.resolve(e), [3, 4];
        case 3:
          return r = n.sent(), t.reject(r), [3, 4];
        case 4:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
var C = (
  /** @class */
  function() {
    function a(t) {
      var e = this;
      this._preInitBuffer = new v(), this.trackSubmit = this._createMethod("trackSubmit"), this.trackClick = this._createMethod("trackClick"), this.trackLink = this._createMethod("trackLink"), this.pageView = this._createMethod("pageview"), this.identify = this._createMethod("identify"), this.reset = this._createMethod("reset"), this.group = this._createMethod("group"), this.track = this._createMethod("track"), this.ready = this._createMethod("ready"), this.alias = this._createMethod("alias"), this.debug = this._createChainableMethod("debug"), this.page = this._createMethod("page"), this.once = this._createChainableMethod("once"), this.off = this._createChainableMethod("off"), this.on = this._createChainableMethod("on"), this.addSourceMiddleware = this._createMethod("addSourceMiddleware"), this.setAnonymousId = this._createMethod("setAnonymousId"), this.addDestinationMiddleware = this._createMethod("addDestinationMiddleware"), this.screen = this._createMethod("screen"), this.register = this._createMethod("register"), this.deregister = this._createMethod("deregister"), this.user = this._createMethod("user"), this.VERSION = p, this._promise = t(this._preInitBuffer), this._promise.then(function(r) {
        var n = r[0], s = r[1];
        e.instance = n, e.ctx = s;
      }).catch(function() {
      });
    }
    return a.prototype.then = function() {
      for (var t, e = [], r = 0; r < arguments.length; r++)
        e[r] = arguments[r];
      return (t = this._promise).then.apply(t, e);
    }, a.prototype.catch = function() {
      for (var t, e = [], r = 0; r < arguments.length; r++)
        e[r] = arguments[r];
      return (t = this._promise).catch.apply(t, e);
    }, a.prototype.finally = function() {
      for (var t, e = [], r = 0; r < arguments.length; r++)
        e[r] = arguments[r];
      return (t = this._promise).finally.apply(t, e);
    }, a.prototype._createMethod = function(t) {
      var e = this;
      return function() {
        for (var r, n = [], s = 0; s < arguments.length; s++)
          n[s] = arguments[s];
        if (e.instance) {
          var u = (r = e.instance)[t].apply(r, n);
          return Promise.resolve(u);
        }
        return new Promise(function(d, l) {
          e._preInitBuffer.push({
            method: t,
            args: n,
            resolve: d,
            reject: l,
            called: !1
          });
        });
      };
    }, a.prototype._createChainableMethod = function(t) {
      var e = this;
      return function() {
        for (var r, n = [], s = 0; s < arguments.length; s++)
          n[s] = arguments[s];
        return e.instance ? ((r = e.instance)[t].apply(r, n), e) : (e._preInitBuffer.push({
          method: t,
          args: n,
          resolve: function() {
          },
          reject: console.error,
          called: !1
        }), e);
      };
    }, a;
  }()
);
export {
  C as AnalyticsBuffered,
  v as PreInitMethodCallBuffer,
  i as callAnalyticsMethod,
  M as flushAddSourceMiddleware,
  w as flushAnalyticsCallsInNewTask,
  _ as flushOn,
  b as flushSetAnonymousID
};
//# sourceMappingURL=index39.js.map
